export default "__VITE_ASSET__C45TzX6X__"